module.exports = __webpack_public_path__ + "img/ws-banner-2.e059f073.jpg";